import '/components/estate-recently-viewed/estate-recently-viewed';
import '/components/estate-recently-viewed/estate-recently-viewed.scss';
